export default function IconAgent({ color = 'currentColor', width = 24, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.52941 6.70605H18.2941C18.9182 6.70605 19.5166 6.95395 19.9579 7.39521C20.3992 7.83648 20.6471 8.43496 20.6471 9.059V10.2355L21.8235 11.4119V14.9413L20.6471 16.1178V19.6472C20.6471 20.2713 20.3992 20.8697 19.9579 21.311C19.5166 21.7523 18.9182 22.0002 18.2941 22.0002H6.52941C5.90537 22.0002 5.30689 21.7523 4.86563 21.311C4.42437 20.8697 4.17647 20.2713 4.17647 19.6472V16.1178L3 14.9413V11.4119L4.17647 10.2355V9.059C4.17647 8.43496 4.42437 7.83648 4.86563 7.39521C5.30689 6.95395 5.90537 6.70605 6.52941 6.70605V6.70605Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0588 17.2939H14.7647'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.29417 12.5881C8.61904 12.5881 8.8824 12.3247 8.8824 11.9999C8.8824 11.675 8.61904 11.4116 8.29417 11.4116C7.96929 11.4116 7.70593 11.675 7.70593 11.9999C7.70593 12.3247 7.96929 12.5881 8.29417 12.5881Z'
        fill={color}
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.5294 12.5881C16.8543 12.5881 17.1176 12.3247 17.1176 11.9999C17.1176 11.675 16.8543 11.4116 16.5294 11.4116C16.2045 11.4116 15.9412 11.675 15.9412 11.9999C15.9412 12.3247 16.2045 12.5881 16.5294 12.5881Z'
        fill={color}
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.8824 6.70588L7.70593 2'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9412 6.70588L17.1176 2'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
